module.exports = __webpack_public_path__ + "static/media/swift.bdcfe175.svg";